import { MGPOptional } from '@everyboard/lib';
import { BooleanConfig } from '../../../config/BooleanConfig';
import { NumberConfig } from '../../../config/NumberConfig';
import { RulesConfigDescription } from '../../../config/RulesConfigDescription';
import { RulesConfigDescriptionLocalizable } from '../../../config/RulesConfigDescriptionLocalizable';
import { MGPValidators } from '../../../utils/MGPValidator';
import { AbstractCheckersRules, CheckersOptionLocalizable } from '../common/AbstractCheckersRules';
export class InternationalCheckersRules extends AbstractCheckersRules {
    static singleton = MGPOptional.empty();
    static RULES_CONFIG_DESCRIPTION = new RulesConfigDescription({
        name: () => $localize `International Checkers`,
        config: {
            playerRows: new NumberConfig(4, RulesConfigDescriptionLocalizable.NUMBER_OF_PIECES_ROWS, MGPValidators.range(1, 99)),
            emptyRows: new NumberConfig(2, RulesConfigDescriptionLocalizable.NUMBER_OF_EMPTY_ROWS, MGPValidators.range(1, 99)),
            width: new NumberConfig(10, RulesConfigDescriptionLocalizable.WIDTH, MGPValidators.range(2, 99)),
            canStackPieces: new BooleanConfig(false, CheckersOptionLocalizable.STACK_PIECES),
            mustMakeMaximalCapture: new BooleanConfig(true, CheckersOptionLocalizable.MAXIMAL_CAPTURE),
            simplePieceCanCaptureBackwards: new BooleanConfig(true, CheckersOptionLocalizable.SIMPLE_PIECE_CAN_CAPTURE_BACKWARDS),
            promotedPiecesCanFly: new BooleanConfig(true, CheckersOptionLocalizable.PROMOTED_PIECES_CAN_TRAVEL_LONG_DISTANCES),
            occupyEvenSquare: new BooleanConfig(false, CheckersOptionLocalizable.OCCUPY_EVEN_SQUARE),
            frisianCaptureAllowed: new BooleanConfig(false, CheckersOptionLocalizable.FRISIAN_CAPTURE_ALLOWED),
            canPromoteMidCapture: new BooleanConfig(false, CheckersOptionLocalizable.CAN_PROMOTE_MID_CAPTURE),
        },
    });
    static get() {
        if (InternationalCheckersRules.singleton.isAbsent()) {
            InternationalCheckersRules.singleton = MGPOptional.of(new InternationalCheckersRules());
        }
        return InternationalCheckersRules.singleton.get();
    }
    getRulesConfigDescription() {
        return InternationalCheckersRules.RULES_CONFIG_DESCRIPTION;
    }
}
